import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MaterialModule } from '../../material.module';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [
		BreadcrumbComponent
	],
	imports: [
		CommonModule,
		MaterialModule,
		RouterModule
	],
	exports: [
		BreadcrumbComponent
	]
})
export class BreadcrumbsModule { }
